import { Chip } from "@narmi/design_system";
import { Dialog } from "cerulean";
import { useLocalization } from "@fluent/react";
import {
  WIRE_AND_ACH_STATUS_DEFINITIONS,
  ACH_ONLY_STATUS_DEFINITIONS,
} from "./statusDefinitionsConfig";
import type { StatusDefinition } from "./statusDefinitionsConfig";
import styles from "./StatusDefinitionsDialog.module.scss";

type StatusDefinitionsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
};

const StatusRow = ({ definition, borderBottom = true }: { definition: StatusDefinition; borderBottom?: boolean }) => {
  const { l10n } = useLocalization();
  return (
    <div className={`${styles.statusItem} ${borderBottom ? styles.borderBottom : ""}`}>
      <div>
        <Chip
          kind={definition.kind}
          startIcon={definition.startIcon}
          label={l10n.getString(definition.labelKey)}
        />
      </div>
      <p className={styles.statusDescription}>
        {l10n.getString(definition.descriptionKey)}
      </p>
    </div>
  );
};

const StatusDefinitionsDialog = ({
  isOpen,
  onClose,
}: StatusDefinitionsDialogProps) => {
  const { l10n } = useLocalization();

  return (
    <Dialog
      width="623px"
      isOpen={isOpen}
      onUserDismiss={onClose}
      title={l10n.getString("file-import-status-definitions-title")}
    >
      <div className={styles.dialogContent}>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            {l10n.getString("file-import-status-section-wire-ach")}
          </div>
          <div className={styles.statusList}>
            {WIRE_AND_ACH_STATUS_DEFINITIONS.map((definition) => (
              <StatusRow key={definition.key} definition={definition} />
            ))}
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            {l10n.getString("file-import-status-section-ach-only")}
          </div>
          <div className={styles.statusList}>
            {ACH_ONLY_STATUS_DEFINITIONS.map((definition, index) => (
              <StatusRow
                key={definition.key}
                definition={definition}
                borderBottom={index !== ACH_ONLY_STATUS_DEFINITIONS.length - 1}
              />
            ))}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default StatusDefinitionsDialog;
